var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header container-fluid d-flex justify-content-between align-items-center",class:{'header-open-state': _vm.get_sidebar_open_state,
     'header-menu-hidden-state': !_vm.sidebarMenuVisible}},[_c('Logo'),_c('Burger'),_c('HeaderAccountBlock')],1)}
var staticRenderFns = []

export { render, staticRenderFns }